// Components/PrivateRoute.js

import React from "react";
import { Navigate } from "react-router-dom";
import { getUserData } from "../Utils/localStorageUtils";

const PrivateRoute = ({ children }) => {
  const userData = getUserData(); // Check if user data exists in localStorage

  // If user is authenticated, render the child components, else redirect to /signup
  return userData ? children : <Navigate to="/signup" replace />;
};

export default PrivateRoute;
